import { UseMixins } from "../mixins/use_mixins.js";
import { UsingTemplate } from "../mixins/using_template.js";
import { WithoutStyleEncapsulation } from "../mixins/without_style_encapsulation.js";
import { DickTokComponent } from "./Component.js";

/**
 * A component that is "standalone" because it provides its own template that
 * is rendered client-side.
 *
 * Components must implement the static `template` property to return a
 * DocumentFragment (by calling the createFragment() utility function).
 *
 * Uses the shadow DOM for templating and composition (slots), but ignores
 * style encapsulation by adopting stylesheets from the document.
 */
export class DickTokStandaloneComponent extends UseMixins(DickTokComponent, [
  UsingTemplate,
  WithoutStyleEncapsulation,
]) {
  /**
   * @param {HTMLSlotElement} slot
   * @returns {boolean}
   */
  hasNodes(slot) {
    return slot.assignedNodes().length > 0;
  }

  /**
   * @param {HTMLSlotElement} slot
   * @returns {boolean}
   */
  hasElements(slot) {
    return slot.assignedElements().length > 0;
  }
}
